import React, { Component } from 'react';
import { connect } from 'react-redux';
import BrandForm from './BrandForm'
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class BrandDetail extends Component{
  componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('brand_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <BrandForm
        edit
        title="Brand Detail"
        {...this.props}
      />
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);
export default enhance(privateView(BrandDetail))